import React, { useState, useEffect } from 'react';
import styles from '../phiosophy.module.css';

const EditPublic401kModal = ({ isOpen, onClose, data, onSave, loading }) => {
  const [formData, setFormData] = useState({
    ein: '',
    employer_name: '',
    type_of_plan: '',
    url: '',
    plan_rating: 0,
    employer_match_sub_header: '',
    employer_match_description: '',
    employer_match_star_rating: 0,
    vesting_schedule_sub_header: '',
    vesting_schedule_description: '',
    vesting_schedule_star_rating: 0,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        ein: data.ein || '',
        employer_name: data.employer_name || '',
        type_of_plan: data.type_of_plan || '',
        url: data.url || '',
        plan_rating: data.plan_rating || 0,
        employer_match_sub_header: data.employer_match_sub_header || '',
        employer_match_description: data.employer_match_description || '',
        employer_match_star_rating: data.employer_match_star_rating || 0,
        vesting_schedule_sub_header: data.vesting_schedule_sub_header || '',
        vesting_schedule_description: data.vesting_schedule_description || '',
        vesting_schedule_star_rating: data.vesting_schedule_star_rating || 0,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: (name.includes('rating') || name === 'plan_rating') ? parseInt(value) || 0 : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(data.id, formData);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Edit 401k Data</h2>
          <button className={styles.closeButton} onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>EIN</label>
            <input
              type="text"
              name="ein"
              value={formData.ein}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Employer Name</label>
            <input
              type="text"
              name="employer_name"
              value={formData.employer_name}
              onChange={handleChange}
              className={styles.formInput}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Type of Plan</label>
            <input
              type="text"
              name="type_of_plan"
              value={formData.type_of_plan}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>URL Slug</label>
            <input
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              className={styles.formInput}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Plan Rating (0-5)</label>
            <input
              type="number"
              name="plan_rating"
              min="0"
              max="5"
              value={formData.plan_rating}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Match Sub-Header</label>
            <input
              type="text"
              name="employer_match_sub_header"
              value={formData.employer_match_sub_header}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Match Description</label>
            <textarea
              name="employer_match_description"
              value={formData.employer_match_description}
              onChange={handleChange}
              className={styles.formTextarea}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Match Star Rating (0-5)</label>
            <input
              type="number"
              name="employer_match_star_rating"
              min="0"
              max="5"
              value={formData.employer_match_star_rating}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Vesting Sub-Header</label>
            <input
              type="text"
              name="vesting_schedule_sub_header"
              value={formData.vesting_schedule_sub_header}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Vesting Description</label>
            <textarea
              name="vesting_schedule_description"
              value={formData.vesting_schedule_description}
              onChange={handleChange}
              className={styles.formTextarea}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Vesting Star Rating (0-5)</label>
            <input
              type="number"
              name="vesting_schedule_star_rating"
              min="0"
              max="5"
              value={formData.vesting_schedule_star_rating}
              onChange={handleChange}
              className={styles.formInput}
            />
          </div>
          <div className={styles.modalFooter}>
            <button type="button" className={styles.cancelButton} onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className={styles.saveButton} disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPublic401kModal;
